'use client';

import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import SelectionChips from '@alltrails/denali/components/SelectionChips';
import { CategorySlug } from '@/types/newsroom';

type FilterOption = CategorySlug | 'all';

type CategoryFilterProps = {
  selectedCategory: FilterOption;
  setCategory: (category: FilterOption) => void;
  className?: string;
};

export default function CategoryFilter({ selectedCategory, setCategory, className }: CategoryFilterProps) {
  const intl = useIntl();

  const filterOptions = useMemo(
    () => [
      { id: 'all', label: intl.formatMessage({ defaultMessage: 'All' }) },
      { id: 'community', label: intl.formatMessage({ defaultMessage: 'Community' }) },
      { id: 'company', label: intl.formatMessage({ defaultMessage: 'Company' }) },
      { id: 'product', label: intl.formatMessage({ defaultMessage: 'Product' }) },
      { id: 'trail-stories', label: intl.formatMessage({ defaultMessage: 'Trail Stories' }) }
    ],
    [intl]
  );

  const selectedChip = useMemo(() => filterOptions.find(option => option.id === selectedCategory), [filterOptions, selectedCategory]);

  const handleCategoryChange = useCallback(
    (selectedChip: { id: string; label: string }) => {
      setCategory(selectedChip.id as FilterOption);
    },
    [setCategory]
  );

  return (
    <div className={className}>
      <SelectionChips
        title={intl.formatMessage({ defaultMessage: 'Filter by category' })}
        chips={filterOptions}
        selectedChips={selectedChip ? [selectedChip] : []}
        onChange={handleCategoryChange}
        isMultiSelect={false}
      />
    </div>
  );
}

export type { FilterOption };
